/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { API_IMG_ANNOUNCE_FILE, AnnounceService, AnnouncementDto, AnnouncementFilterDto, AsessFilterDto, JobService, SeasonDto, SystemDateDisplayFormat } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '_metronic/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'
import moment from 'moment'
import clsx from 'clsx'
import { ModalBox } from 'app/components/modals/ModalBox'


const AnnouceSettingPage: FC = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<AnnouncementDto[]>([])

    const initParam: AnnouncementFilterDto = {
        page: 0,
        length: 10
    }
    const [searchParam, setSearchParam] = useState<AnnouncementFilterDto>(initParam)
  
    const columnDef: ColDef<AnnouncementDto>[] = [
        {
            label: 'Id',
            renderItem: ({item, index}) => item.id,
            hidden: true
        },
        {
            label: 'วันที่หมดอายุ',
            renderItem: ({item, index}) => moment(item.expiredDate).format(SystemDateDisplayFormat),
        },
        {
            label: 'หัวข้อ',
            renderItem: ({item, index}) => item.title,
        },
        
        {
            label: 'ประเภท',

            renderItem: ({item, index}) => item.type
        },  
        // {
        //     label: 'รายละเอียด',

        //     renderItem: ({item, index}) => item.description
        // },        
        {
            label: 'active',

            renderItem: ({item, index}) => item.isActive ? 'Active' : 'InActive'
        },

        {
            label: '',
            renderItem: ({item}) => <>
                <div className='text-center'>
                    <button
                        type='button'
                        onClick={(e) => {
                            navigate('/setting/announce/' + item.id)
                        }
                        }
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3'
                        />
                    </button>


                </div>
            </>,
        },
    ]

    const tableSetting: TableSetting<AnnouncementDto> = {
        showColAction: false,
        primaryKey: (item: AnnouncementDto) => item,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: true,
        showFilter: false,
        showSearch: false,
        btnAddText: 'เพิ่ม ประกาศ',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/setting/announce/new')
    }

    useEffect(() => {
        const load = () => {
            if (lastSeason) {
                AnnounceService.Search(searchParam).then((result) => {
                    const row = result.data.result
                    setData(row)
                })
            }
        }
        load()
    }, [lastSeason, reload])

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>
                <div className='card-header cursor-pointer'>

                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>
                </div>
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div >
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={data}
                        />
                        {/* end::Table */}
                    </div>

                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { AnnouceSettingPage }
